"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urijs = _interopRequireDefault(require("urijs"));

var _ResourcePropTypes = _interopRequireDefault(require("./ResourcePropTypes.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RESOURCE_ICONS = [["icon-geo", require("./assets/geo.png")], ["icon-ena", require("./assets/ena.png")], ["icon-ega", require("./assets/ega.png")], ["icon-gsea-reactome", require("./assets/gsea-reactome.png")], ["icon-gsea-interpro", require("./assets/gsea-interpro.png")], ["icon-gsea-go", require("./assets/gsea-go.png")], ["icon-ma", require("./assets/ma-plot.png")], ["icon-ae", require("./assets/ae-logo.png")], ["icon-pride", require("./assets/pride-new-logo.png")], ["icon-experiment-design", require("./assets/experiment-design.png")], ["icon-Rdata", require("./assets/r-object.png")], ["icon-analytics", require("./assets/download-analytics.png")], ["icon-clustered-heatmap", require("./assets/download-clustered-heatmap.png")], ["icon-foldchange", require("./assets/download-fc.png")], ["icon-normalized-expressions", require("./assets/download-normalized-expressions.png")], ["icon-raw-counts", require("./assets/download-raw-counts.png")], ["icon-tsv", require("./assets/download-tsv.png")]];

var htmlEntity = function htmlEntity(type) {
  var maybeEntity = [["link", "\uD83D\uDD17"]].find(function (e) {
    return type.includes(e[0]);
  });
  return maybeEntity && /*#__PURE__*/_react["default"].createElement("span", null, maybeEntity[1]);
};

var icon = function icon(type, pathToResources) {
  var maybeImg = RESOURCE_ICONS.find(function (e) {
    return type === e[0];
  });
  return maybeImg ? /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      marginRight: "0.5rem",
      height: "32px"
    },
    src: (0, _urijs["default"])(maybeImg[1], pathToResources)
  }) : /*#__PURE__*/_react["default"].createElement("i", {
    style: {
      marginRight: "0.5rem",
      fontSize: "x-large"
    },
    className: "icon icon-fileformats ".concat(type)
  });
};

var Icon = function Icon(_ref) {
  var type = _ref.type,
      pathToResources = _ref.pathToResources;
  return htmlEntity(type) || icon(type, pathToResources) || /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: "0.5rem",
      marginRight: "0.5rem"
    }
  }, " \xB7 ");
};

Icon.propTypes = {
  type: _ResourcePropTypes["default"].type,
  pathToResources: _propTypes["default"].string.isRequired
};
var _default = Icon;
exports["default"] = _default;